import { render } from "./kefuOrgList.vue?vue&type=template&id=552f6e12&scoped=true"
import script from "./kefuOrgList.vue?vue&type=script&lang=js"
export * from "./kefuOrgList.vue?vue&type=script&lang=js"

import "./kefuOrgList.vue?vue&type=style&index=0&id=552f6e12&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-552f6e12"]])

export default __exports__